import { MessageCircle } from "lucide-react";

function ConsentTag({ account, marketing, testId }) {
  const base = "rounded-full px-2 py-0.5 text-[11px] font-bold whitespace-nowrap";
  if (!account && !marketing) return <span className={`${base} bg-slate-700 text-slate-300`} data-testid={`${testId}-consent`}>No consent</span>;
  return (
    <>
      {account && <span className={`${base} bg-emerald-500/20 text-emerald-300`} title="Account, payment and progress messages" data-testid={`${testId}-consent`}>Consent ✓</span>}
      {marketing && <span className={`${base} bg-amber-400/20 text-amber-200`} title="News and offers" data-testid={`${testId}-offers`}>Offers ✓</span>}
    </>
  );
}

export default function WhatsAppLink({ number, name, testId, consentAccount, consentMarketing, message, messageLabel }) {
  const text = encodeURIComponent(`Hello${name ? ` ${name}` : ""}, this is Marie-Yanna from Anou Appran.`);
  const digits = (number || "").replace(/\D/g, "");
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      {number ? (
        <a href={`https://wa.me/${number.replace(/\D/g, "")}?text=${text}`} target="_blank" rel="noreferrer" data-testid={testId}
          title="Chat on WhatsApp"
          className="inline-flex items-center gap-1 rounded-full bg-[#25D366] text-slate-900 px-2.5 py-0.5 text-xs font-bold hover:bg-[#3be37a] whitespace-nowrap">
          <MessageCircle size={12} /> {number}
        </a>
      ) : <span className="text-xs text-slate-500" data-testid={testId}>No WhatsApp</span>}
      {number && message && (
        <a href={`https://wa.me/${digits}?text=${encodeURIComponent(message)}`} target="_blank" rel="noreferrer" data-testid={`${testId}-template`}
          className="inline-flex items-center gap-1 rounded-full border-2 border-[#25D366] text-[#25D366] px-2.5 py-0.5 text-xs font-bold hover:bg-[#25D366]/15 whitespace-nowrap">
          <MessageCircle size={12} /> {messageLabel}
        </a>
      )}
      <ConsentTag account={consentAccount} marketing={consentMarketing} testId={testId} />
    </span>
  );
}
